export var COLORS = {
    primary: '#00a991',
    primaryAlt: '#59bfa5',
    primaryAltTransparent: 'rgba(88, 199, 171, 0.51)',
    onPrimary: '#FFFFFF',
    secondary: '#07285B',
    onSecondary: '#FFFFFF',
    accent: '#FF0058',
    warning: '#F2994A',
    onAccent: '#FFFFFF',
    background: 'rgba(255, 255, 255, 0)',
    onBackground: 'rgb(31,31,31)',
    backgroundHover: 'rgba(255, 255, 255, 0.35)',
    dragging: 'rgba(189,189,189,0.99)',
    border: 'rgba(0, 0, 0, 0.25)',
    droppableHover: 'rgb(220,220,220)',
    secondaryBackground: '#07285B',
    secondaryBackgroundPale: 'rgba(7,40,91,0.08)',
    secondaryBackgroundAlt: '#395a71',
    onSecondaryBackgroundAlt: '#627989',
    onSecondaryBackground: '#FFFFFF',
    pageBackground: '#efefef',
    darkBackground: '#000000',
    archive: '#828282',
    tagBoxDefault: '#e9e9e9',
    darkColor: '#252525',
    redColor: '#eb5757',
    warningMessage: '#3c3c3c',
    warningBlue: '#3C8EFD',
    lightBlack: '#2D2D2D',
    mutedGray: '#c2c2c2',
    disabledBackground: '#e0e0e0',
    lightGrayColor: '#f3f3f3',
    bluishGray: '#f4f8fa',
    reddishGray: '#8c8c8c',
    green: '#27ae60',
    veryLightGray: '#D9D9D9',
    commonBlue: '#ebf3fe',
    blue: '#1f68ca',
    commonGreen: '#E9F6EF',
    redBg: '#FDEEEE',
    grayBg: '#F8F8F8',
};
export var navbarColors = {
    dark: '#000000',
    primary: '#252525',
    lightGray: '#E9E9E9',
    secondary: '#FFFFFF',
    hoverNavBar: '#063C63',
    defaultGreen: '#00F0AA',
    hoverBackground: '#353535',
    hoverNavBarLight: '#FAFBFC',
    defaultGreenHover: '#00D899',
    hoverNavBarBorder: '#00F0AA',
    bottomBar: 'rgb(220,220,220)',
    subActiveBackground: '#2D2D2D',
    boxShadow: "rgba(0, 0, 0, 0.15)",
};
export var STATUS_COLORS = {
    PENDING: '#858585',
    WARNING: '#fda862',
    LIVE: '#27AE60',
};
